import React from 'react';

import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import styled from 'styled-components';
import {
  BodyContainer,
  Contents,
  Header,
    MainContainer,
  SideMenu,
} from 'view/components';
import About from 'view/pages/CreateCoaching/components/tab/About';
import Details from 'view/pages/CreateCoaching/components/tab/Details';
import Products from 'view/pages/CreateCoaching/components/tab/Products';
import Showcase from 'view/pages/CreateCoaching/components/tab/Showcase';
import Testimonials
  from 'view/pages/CreateCoaching/components/tab/Testimonials';
import {useRecoilValue} from "recoil";
import {loading} from "../../../state";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

interface CreateProps {
    selected?: any;
}

const CreateCoaching: React.FC<CreateProps> = () => {
    const location = useLocation();  
    const { step } = useParams();
    const navigate = useNavigate()
    const loadingState = useRecoilValue(loading)

    console.log('step', step)

    const el = () => {
        switch (step) {
            case "details": {
                return <Details />;
            }
            case "products": {
                return <Products />;
            }            
            case "about": {
                return <About />;
            }
            case "showcase": {
                return <Showcase />;
            }
            case "testimonials": {
                return <Testimonials />;
            }
            default:
                break;
        };
    };
    const onClickSideMenu = (step) => {        
        navigate(`/create_coaching/${step}`,{
            state: { createId : location?.state?.createId || "" }
        });
    };
    return (
        <Container>
            <BodyContainer>
                <ContentsWrap>
                    <SideMenu onClick={onClickSideMenu} selected={step} loading={loadingState} />
                    <Wrap>
                        <Header />
                        <MainContainer>
                            <div className={"main_inner"} style={{ padding: 30 }}>
                                <Contents title={step}>{el()}</Contents>
                            </div>
                        </MainContainer>
                    </Wrap>
                </ContentsWrap>
            </BodyContainer>
        </Container>
    );
};
export default CreateCoaching;

const Container = styled.div`
    display: flex;
`;
const ContentsWrap = styled.div`
    display: flex;
    width: calc(100% - 298);
    max-width: 1440px;
    height: 100%;
    margin: auto;
`;
const Wrap = styled.div`
    .commonContents{
        box-shadow: 0px 0px 10px 0px #ddc16080!important;
    }
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
    @media screen and (max-width: 768px) {
        //flex-direction: column;
        //width: 100%;
        //& > div{
        //    width: 100%;
        //}
        .main_inner{
            padding-top: 20px!important;
            padding-left: 20px!important;
            padding-right: 20px!important;
            padding-bottom: 20px!important;
        }
        position: absolute;
    }
`;